function isEmpty(obj: any): boolean {
  if (obj) {
    return Object.keys(obj).length === 0;
  }
  return true;
}

function allUndefined(obj: any): boolean {
  return Object.values(obj).every(el => el === undefined);
}

function getValue(object: any, path: string): string | boolean {
  return path
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .split('.')
    .reduce((o: any, k: string | number) => (o || {})[k], object);
}

export { isEmpty, allUndefined, getValue };
